import MutateCollection from "./MutateCollection";

export default MutateCollection